// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2rErk","item":"PaymentsMobile_item__2DSkw","label":"PaymentsMobile_label__1sHt3","amount":"PaymentsMobile_amount__2ZL0n"};